<template>
  <div>
    <!-- page-wrapper Start-->
    <div class="page-wrapper" id="canvas-bookmark">
      <!-- Page Header Start-->
      <div class="page-main-header" :class="{ open:toggle_sidebar_var }">
        <div class="main-header-right row">
          <div class="main-header-left d-lg-none">
            <div class="logo-wrapper"><router-link :to="{ name: 'default'}" ><img src="../assets/images/logo-dark.png" alt=""></router-link></div>
          </div>
          <div class="mobile-sidebar">
            <div class="media-body text-right switch-sm">
              <label class="switch" v-on:click="toggle_sidebar"><feather type="align-left"></feather></label>
            </div>
          </div>
          <div class="nav-right col">
            <ul class="nav-menus" :class="{ open: mobile_toggle }">
              <li>
                <form class="form-inline search-form">
                  <div class="form-group">
                    <input :class="{ open: mobile_search }" class="form-control-plaintext"  v-on:keyup="searchTerm" v-model="terms" type="text" placeholder="Search..">
                    <div :class="searchResult ? 'Typeahead-menu is-open' : 'Typeahead-menu'" v-if="menuItems.length">
                      <div class="ProfileCard u-cf" v-for="(menuItem,index) in menuItems.slice(0, 8)" :key="index">
                       <div class="ProfileCard-avatar header-search">
                         <feather :type="menuItem.icon"></feather>
                       </div>
                       <div class="ProfileCard-details">
                        <div class="ProfileCard-realName">
                         <span @click='removeFix()'><router-link :to="{path:menuItem.path}" class="realname">{{menuItem.title}}</router-link></span>
                       </div>
                     </div>
                   </div>
                 </div>
                 <div :class="searchResultEmpty ? 'Typeahead-menu is-open' : 'Typeahead-menu'" >
                  <div class="tt-dataset tt-dataset-0">
                    <div class="EmptyMessage">
                      Your search turned up 0 results. Opps There are no result found.
                    </div>
                  </div>
                </div>
                <span class="d-sm-none" v-on:click="mobile_search = !mobile_search">
                  <feather type="search"></feather>
                </span>
              </div>
            </form>
          </li>
          <li>
            <router-link to="/upgrade" class="btn btn-pill btn-primary">Upgrade</router-link>
          </li>
          <li class="onhover-dropdown"><feather type="bell"></feather><span class="dot" v-if="notifications_data.length > 0"></span>
            <ul class="notification-dropdown onhover-show-div">
              <li>Notification <span class="badge badge-pill badge-primary pull-right">{{notifications_data.length}}</span></li>
              <li class="not-found-notification" v-if="notifications_data.length === 0">Not found notification</li>
              <li v-else v-for="notifications in notifications_data.slice(0, 3)" :key="notifications.id">
                <div class="media">
                  <div class="media-body">
                    <h6 class="mt-0">
                      <span><feather class="shopping-color" type="shopping-bag"></feather></span>
                      {{notifications.notificationCaption}}</h6>
                    <p class="mb-0">{{notifications.friendlyMessage}}</p>
                  </div>
                </div>
              </li>
              <li class="bg-light txt-dark" v-b-modal.modal-2>
                <a>All</a>
                notification</li>
                <b-modal id="modal-2" title="Notifications" class="theme-modal">
                  <ul class="notification-modal">
                    <li v-if="notifications_data.length.length === 0" class="not-found-notification">Not found notification</li>
                    <li v-for="notifications in notifications_data" :key="notifications.id">
                      <div class="media">
                        <div class="media-body">
                          <h6 class="mt-0">
                            <span><feather class="shopping-color" type="shopping-bag"></feather></span>
                            {{notifications.notificationCaption}}</h6>
                          <p class="mb-0">{{notifications.friendlyMessage}}</p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </b-modal>
            </ul>
          </li>
          <li class="onhover-dropdown">
            <div class="media align-items-center">
              <img class="align-self-center pull-right img-50 rounded-circle" v-if="getAvatarImg" :src="getAvatarImg" alt="header-user">
              <img class="align-self-center pull-right img-50 rounded-circle" v-else src="../assets/images/dashboard/user.png" alt="header-user">
              <div class="dotted-animation"><span class="animate-circle"></span><span class="main-circle"></span></div>
            </div>
            <ul class="profile-dropdown onhover-show-div p-20">
              <li>
                <router-link :to="{ name: 'profile', params: params({url: user.referralCode})}">
                  <feather type="user"></feather>Profile
                </router-link>
              </li>
              <li><router-link to="/users/edit"><feather type="edit"></feather> Edit Profile</router-link></li>
              <li><a @click.prevent="logout" href="#"><feather type="log-out"></feather> Logout</a></li>
            </ul>
          </li>
        </ul>
        <div class="d-lg-none mobile-toggle pull-right" v-on:click="mobile_toggle = !mobile_toggle"><feather type="more-horizontal"></feather></div>
      </div>
    </div>
  </div>
  <!-- Page Header Ends -->
</div>
</div>
</template>
<script>
var body = document.getElementsByTagName("body")[0];
import { mapState } from "vuex";
import { mapGetters } from 'vuex'
import UserAuth from '../auth/js/index';

export default {
  name: 'Search',
  data() {
    return {
      terms: '',
      searchResult: false,
      searchResultEmpty: false,
      toggle_sidebar_var:false,
      clicked:false,
      mobile_toggle:false,
      mobile_search: false,
      user: [],
      url: process.env.VUE_APP_URL,
      notifications_data: []
    }
  },
  computed: {
    ...mapState({
      menuItems: state => state.menu.searchData,
    }),
    ...mapGetters([
      'getAvatarImg',
    ])
  },
  mounted() {
    this.$store.dispatch('getUser');
    this.user = JSON.parse(localStorage.getItem('userinfo'));

    this.$store.dispatch('getNotifications').then(() => {
      if (this.$store.state.notifications) {
        this.notifications_data = this.$store.state.notifications;
      } else {
        this.notifications_data = [];
      }
    }).catch(() => {
      this.notifications_data = []
    });
  },
  methods: {
    searchTerm: function() {
      this.$store.dispatch('menu/searchTerm', this.terms)
    },
    addFix() {
      body.classList.add("offcanvas")
      this.searchResult = true;
    },
    logout: function() {
      UserAuth.Logout();
      this.$router.replace('/auth/login')
    },
    removeFix() {
      body.classList.remove("offcanvas")
      this.searchResult = false;
      this.terms = ''
    },
    toggle_sidebar(){
      this.toggle_sidebar_var = !this.toggle_sidebar_var,
      this.clicked = !this.toggle_sidebar_var,
      this.$emit('clicked',this.clicked)
    },
    params(newParams) {
      return {
        ...this.$route.params,
        ...newParams
      }
    }
  },
  watch: {
    menuItems: function () {
      this.terms ? this.addFix() : this.removeFix();
      if(!this.menuItems.length)
        this.searchResultEmpty = true;
      else
        this.searchResultEmpty = false;
    }
  }
}
</script>
<style>
  .media.align-items-center {
    background: #f8f8f8;
    border-radius: 50%;
    width: 50px;
    height: 50px;
  }
  .media.align-items-center img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  ul.notification-modal li {
    display: block;
    padding: 12px 20px;
    border-bottom: 1px solid #f6f7fb;
    text-align: left;
  }
  ul.notification-modal li .media {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-align: start;
    -webkit-box-align: start;
    align-items: flex-start;
  }
  ul.notification-modal > li h6 {
    margin-top: 10px;
    color: #4466f2;
  }
  ul.notification-modal li p {
    margin-left: 30px;
  }
  ul.notification-modal li span i {
    vertical-align: middle;
  }
  ul.notification-modal li svg {
    margin-top: 10px;
    width: 18px;
    height: 18px;
    color: #4466f2;
  }
  ul.notification-modal li span svg {
    margin-top: 0 !important;
    margin-right: 10px;
    vertical-align: text-top;
  }
  ul.notification-modal li:hover {
    background-color: #f6f7fb;
    cursor: pointer;
  }
  ul.notification-dropdown.onhover-show-div .not-found-notification:hover {
    background-color: transparent;
  }
</style>
